import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AuthService } from '@tfs/auth';
import { AccountModuleCurrentTermsResponseDto, TermsApi } from '@tfs/tool-library-library-api';

@Component({
  selector: 'tfs-terms-acceptance-modal',
  imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDividerModule,
  ],
  templateUrl: './terms-acceptance-modal.component.html',
  styleUrl: './terms-acceptance-modal.component.scss',
})
export class TermsAcceptanceModalComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly dialogRef = inject(MatDialogRef<TermsAcceptanceModalComponent>);
  private readonly termsApi = inject(TermsApi);
  private readonly snackBar = inject(MatSnackBar);

  protected currentTermsVersion: WritableSignal<AccountModuleCurrentTermsResponseDto> = signal({});
  protected readonly confirmed = signal(false);

  ngOnInit() {
    this.termsApi.getCurrentTerms().subscribe({
      next: res => this.currentTermsVersion.set(res),
      error: _err => this.snackBar.open('An error occurred'),
    });
  }

  protected acceptAndContinue(): void {
    this.termsApi
      .acceptTerms({
        termsVersionId: this.currentTermsVersion()?.termsVersionId,
        acceptanceChannel: 'Login',
      })
      .subscribe({
        next: _res => {
          this.snackBar.open('Terms and conditions accepted', 'Close');
          this.dialogRef.close(true);
        },
        error: _err => {
          this.snackBar.open('An error has occurred.', 'Close', {
            duration: 3000,
            panelClass: 'error',
          });
          this.dialogRef.close(true);
        },
      });
  }

  protected logOut(): void {
    this.authService.logout();
  }
}
